import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ReportHandler } from './services/handlers/report.handler';
import { HttpReportProvider } from './services/providers/http-report.provider';
import { REPORT_HANDLER, REPORT_PROVIDER } from './tokens/reports.tokens';

/**
 * Registrata nell'injector di radice, non su una rotta lazy: il comando che apre la segnalazione sta
 * nell'intestazione, che esiste prima di ogni rotta.
 */
export function provideReports(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: REPORT_PROVIDER, useClass: HttpReportProvider },
    { provide: REPORT_HANDLER, useClass: ReportHandler },
  ]);
}
